import { gsap } from "gsap";
import { SplitText } from 'gsap/SplitText';
gsap.registerPlugin(SplitText);

const carouselTitle = document.querySelector('#CarouselTitle');

window.onscroll = () => {
    if(window.scrollY > 250){
        document.body.classList.add('scroll');
    } else {
        document.body.classList.remove('scroll');
    }
}
window.onload = () => {
    const splitTitle = SplitText.create(carouselTitle, {type:"chars"});
    carouselTitle.classList.remove('visually-hidden');
    gsap.from(splitTitle.chars, {autoAlpha: 0, rotateY: -90, duration: 0.5, stagger: 0.1, ease: "power2.in"}, 1);
}

// Popups
const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))
